module.exports = "/images/FastcommerceLogo.png?8f94a091de19558f22ea555fbd825806";